<template>
    <div
        class="min-h-screen brand-neutral-4 font-poppins md:w-96 md:mx-auto relative"
    >
        <slot />
    </div>
</template>
